export default __webpack_public_path__ + "static/media/pairs-active.83d58765.svg";